import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "services/axios/axiosInstance";
const url = "admin/messages/conversations/logs";
export const key = ["CHAT_LOGS"];
export const useGetChatLogs = (
  pageSize,
  page,
  orderBy,
  orderType,
  searchBy,
  search,
  dateFrom,
  dateTo,
  params,
  enabled
) =>
  useQuery(
    [...key, params, page, pageSize],
    async () => {
      console.log(dateTo);
      const { data } = await axiosInstance.get(url, {
        params: {
          page,
          per_page: pageSize,
          order_by: orderBy,
          order_type: orderType,
          search_by: searchBy,
          ...(dateFrom !== undefined &&
            dateFrom !== null && { from: dateFrom }),
          ...(dateTo !== undefined &&
            dateTo !== null &&
            dateTo !== "null" && { to: dateTo }),
          search,
        },
        paramsSerializer: (params) => {
          let result = "";
          Object.keys(params).forEach((key) => {
            result += `${key}=${params[key] ?? ""}&`;
          });
          console.log(result);
          return result.substring(0, result.length - 1).replace("=null&", "=&");
        },
      });
      return data;
    },
    {
      enabled,
    }
  );
